import {
  FETCH_ALL_LICENSE_PERMIT_GROUPS,
} from '../../mutation-types';

export default {
  [FETCH_ALL_LICENSE_PERMIT_GROUPS](state, licensePermitGroups) {
    state.all = licensePermitGroups;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/licensePermit/mutations.js